import { makeStyles, shorthands } from '@fluentui/react-components';

export const useActionButtonStyles = makeStyles({
  actionButton: {
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    backgroundColor: 'rgb(255,255,255,0.2)',
    ...shorthands.borderRadius('999px'),
    ...shorthands.border('none'),
    ...shorthands.margin('6px'),
  },
});
